export type ActivityType = 'ALL' | 'MILESTONE' | 'TASK';

export const activityTypeOptions: ISelectOption<ActivityType>[] = [
    { label: 'All', value: 'ALL' },
    { label: 'Milestone', value: 'MILESTONE' },
    { label: 'Task', value: 'TASK' },
];
